export default __webpack_public_path__ + "static/media/image.e533d8e5.svg";